<template>
  <!-- wrap : S -->
  <div>
      <div class="sub_top">
          <SubTitle></SubTitle>
          <div class="sub_tit">
              <div class="sub_tit_inner">
                  <h2>운영전략</h2>
              </div>
          </div>
      </div>

      <!-- container : S -->
      <div class="ptc_container">
          <div class="info_section">
              <div class="info_txt">
                  <p class="txt_typ_1"><span class="txt_ib">측정·분석 프로토콜의</span><span class="txt_ib">공유와 활용</span></p>
              </div>
              <div class="info_graphic">
                  <div class="info_graphic_img">
                      <img src="@/style/new/images/info/operating_01.png" alt="" />
                  </div>
              </div>
          </div>

          <div class="info_section">
              <div class="info_txt">
                  <p class="txt_typ_1">분야별 핵심요소 기술</p>
              </div>
              <div class="info_graphic">
                  <ul class="keyelements">
                      <li>
                          <div class="keyelements_card">
                              <h3>운영</h3>
                              <span class="icon_1"></span>
                              <ul class="keyelements_list">
                                  <li>연구기반혁신 운영위원회</li>
                                  <li>측정분석 협의회(전문위원회)</li>
                                  <li>인적 네트워크(분석전문가)</li>
                              </ul>
                          </div>
                      </li>
                      <li>
                          <div class="keyelements_card">
                              <h3>시스템</h3>
                              <span class="icon_2"></span>
                              <ul class="keyelements_list">
                                  <li>플랫폼 개발</li>
                                  <li>관리/검색체계</li>
                                  <li>연구데이터센터 연계</li>
                              </ul>
                          </div>
                      </li>
                      <li>
                          <div class="keyelements_card">
                              <h3>측정분석 프로토콜</h3>
                              <span class="icon_3"></span>
                              <ul class="keyelements_list">
                                  <li>요소항목 표준화/수집</li>
                                  <li>빅데이터 수집</li>
                                  <li>해석데이터 수집</li>
                                  <li>프로토콜 수집/활용</li>
                              </ul>
                          </div>
                      </li>
                      <li>
                          <div class="keyelements_card">
                              <h3>신측정 분석기술 개발</h3>
                              <span class="icon_4"></span>
                              <ul class="keyelements_list">
                                  <li>미세조직 - 성능 상관관계</li>
                                  <li>작동환경 실시간 이미징</li>
                                  <li>유연박막전지 소재</li>
                                  <li>환경오염인자 고속</li>
                              </ul>
                          </div>
                      </li>
                  </ul>
              </div>
          </div>

          <div class="info_section">
              <div class="info_txt">
                  <p class="txt_typ_1"><span class="txt_ib">프로토콜 공유 플랫폼</span><span class="txt_ib">개발 및 관리/검색 체계</span></p>
              </div>
              <div class="info_graphic">
                  <ul class="search_system">
                      <li>
                          <div class="search_system_card">
                              <div class="search_system_tit">
                                  <h3>수집 모듈</h3>
                                  <p>Collection module</p>
                              </div>
                              <ul class="search_system_list">
                                  <li>표준화된 항목DB 구조화</li>
                                  <li>메타데이터 간의 연관 관계 DB 구성</li>
                                  <li>장비별 데이터 수집 기능</li>
                                  <li>자연어처리 기반 데이터 수집 기능</li>
                              </ul>
                          </div>
                      </li>
                      <li>
                          <div class="search_system_card">
                              <div class="search_system_tit">
                                  <h3>공유 모듈</h3>
                                  <p>Shared module</p>
                              </div>
                              <ul class="search_system_list">
                                  <li>타 연구자와의 노하우 공유기능(채팅)</li>
                                  <li>ReserchGate 등과 같은 SNS기반 연구 공유/협업</li>
                                  <li>엠바고 설정 등 보안 기능</li>
                              </ul>
                          </div>
                      </li>
                      <li>
                          <div class="search_system_card">
                              <div class="search_system_tit">
                                  <h3>활용 모듈</h3>
                                  <p>Utilization module</p>
                              </div>
                              <ul class="search_system_list">
                                  <li>수록된 노하우 구성요소의 자동시각화</li>
                                  <li>수집 한 노하우를 위키디피아 식으로 변환/시각화</li>
                                  <li>측정분석데이터 수동/자동 해석기능</li>
                              </ul>
                          </div>
                      </li>
                      <li>
                          <div class="search_system_card">
                              <div class="search_system_tit">
                                  <h3>검색 모듈</h3>
                                  <p>Search module</p>
                              </div>
                              <ul class="search_system_list">
                                  <li>ElasticSearch 등 빅데이터 검색 환경</li>
                                  <li>
                                      시멘틱 검색<br />
                                      <span class="typ2">
                                          -키워드 / 문장 추출,<br />
                                          -Sentence to Vector 모델생성<br />
                                          -유의어/유사 문장 검색 기능<br />
                                      </span>
                                  </li>
                                  <li>검색도구 활용효과 증진용 키워드 기계학습 모델 개발</li>
                                  <li>연관데이터 검색</li>
                              </ul>
                          </div>
                      </li>
                      <li>
                          <div class="search_system_card">
                              <div class="search_system_tit">
                                  <h3>관리 모듈</h3>
                                  <p>Management module</p>
                              </div>
                              <ul class="search_system_list">
                                  <li>데이터 디지털 객체인 식자 (DOI)부여</li>
                                  <li>데이터 유통 이력 관리 위·변조 방지</li>
                                  <li>데이터의 중복성 및 적정성 검토</li>
                              </ul>
                          </div>
                      </li>
                  </ul>
                  <div class="info_graphic_img">
                      <img src="@/style/new/images/info/operating_02.png" alt="" />
                  </div>
                  <p class="desc_txt">
                      국가 소재연구데이터센터 및 DB간 데이터 (API 개발 및 표 준코드 제정 및 부여), <br />
                      외부 DB(소재정보은행, 국외 DB 등) 데이터 연계활용환경 구축
                  </p>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import SubTitle from "@/views/Platform/Introduce/SubTitle";
export default {
    components: {
        SubTitle
    },
}
</script>
